module.exports = __webpack_public_path__ + "actionClose.fa8946c33309603debaafc1aead7a853.svg";